import React, { lazy } from 'react';
import { Navigate, Link } from 'react-router-dom'
import Result from "../pages/document/result";

const LoginLayouts = lazy(() => import("../layouts/LoginLayouts"));
const IndexLayouts = lazy(() => import("../layouts/IndexLayouts"));
const BasicLayouts = lazy(() => import("../layouts/BasicLayouts"));
const Homepage = lazy(() => import("../pages/homepage"));
const Technology = lazy(() => import("../pages/technology"));
const Product = lazy(() => import("../pages/product"));
const Case = lazy(() => import("../pages/case"));
const CaseDetails = lazy(() => import("../pages/case/details"));
const About = lazy(() => import("../pages/about/about"));
const Join = lazy(() => import("../pages/about/join"));
const News = lazy(() => import("../pages/about/news"));
const NewsDetails = lazy(() => import("../pages/about/news/details"));
const Download = lazy(() => import("../pages/download"));
const Notice = lazy(() => import("../pages/notice"));
const Policy = lazy(() => import("../pages/policy"));

const Document = lazy(() => import("../pages/document"));
const DocumentView = lazy(() => import("../pages/document/view"));
const DocumentConsult = lazy(() => import("../pages/document/consult"));
const DocumentResult = lazy(() => import("../pages/document/result"));





// import LoginLayouts from "../layouts/LoginLayouts";
// import IndexLayouts from "../layouts/IndexLayouts";
// import BasicLayouts from "../layouts/BasicLayouts";
//
// import Homepage from "../pages/homepage";
// import Technology from "../pages/technology";
// import Product from "../pages/product";
// import Case from "../pages/case";
// import CaseDetails from "../pages/case/details";
// import About from "../pages/about/about";
// import Join from "../pages/about/join";
// import News from "../pages/about/news";
// import NewsDetails from "../pages/about/news/details";
// import Download from "../pages/download";
// import Notice from "../pages/notice";
// import Policy from "../pages/policy";


const NoMatch = () => (
	<div style={{margin: "50px"}}>
		<h3>404 NOT FOUND</h3>
		<Link to="/">返回主页</Link>
	</div>
)

// 主路由
// 包括 登录页 索引页 后台页
export const routes = [
	{path: '/', element: <Navigate to={'/index'}/>},
	{path: '/document', element: <Document/>},
	{path: '/doc-view/:id', element: <DocumentView/>},
	{path: '/consult/:id', element: <DocumentConsult/>},
	{path: '/result/:id', element: <DocumentResult/>},
	{path: '/index', element: <IndexLayouts/>},
	{path: '/login', element: <LoginLayouts/>},
	{path: '/login/*', element: <LoginLayouts/>},
	{path: '/*', element: <BasicLayouts/>}
];

// 后台页面路由
export const basicRoutes = [
	{path: '/homepage', element: <Homepage/>},
	{path: '/technology', element: <Technology/>},
	{path: '/product/:id', element: <Product/>},
	{path: '/case/:id', element: <CaseDetails/>},
	{path: '/case', element: <Case/>},
	{path: '/about-us', element: <About/>},
	{path: '/join-us', element: <Join/>},
	{path: '/news/:id', element: <NewsDetails/>},
	{path: '/news', element: <News/>},
	{path: '/download', element: <Download/>},
	{path: '/legal-notice', element: <Notice/>},
	{path: '/privacy-policy', element: <Policy/>},
	{path: '*', element: <NoMatch/>}
];
